
import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home' // 重定向到 '/home' 路由
  },
  {
    path: '/home',
    name: 'Home',
    component: function () {
      return import('../views/Home.vue')
    }
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})



export default router
